import React from 'react';
import { Link } from 'react-router-dom';
import '../Question-bank/questionbank.css';
import './subjectpage.css';
import BackButton from '../../components/backButton';

// CCTE has a single subject; its chapters come from form/question-bank/:code.
const SUBJECTS = [
    { subCode: 'CODE001', subName: 'Computer Competency Test Examination' },
]

const SubjectPage = () => {
    return (
        <div className='qb_page'>
            <BackButton to='/question-bank' />
            <nav className='qb_crumbs'>
                <Link to='/question-bank'>Question Bank</Link>
                <span className='qb_crumb_sep'>/</span>
                <span>Subjects</span>
            </nav>

            <div className='qb_header'>
                <h1 className='qb_title'>Choose a Subject</h1>
                <p className='qb_subtitle'>
                    Pick a subject to see its chapters.
                </p>
            </div>

            <h2 className='qb_section_label'>
                Subjects
                <span className='qb_count'>{SUBJECTS.length} available</span>
            </h2>

            <div className='qb_grid'>
                {SUBJECTS.map((s) => (
                    <Link
                        key={s.subCode}
                        to={'/chapter-page/' + s.subCode}
                        className='qb_card'
                    >
                        <span className='qb_card_code'>{s.subCode}</span>
                        <p className='qb_card_name'>{s.subName}</p>
                        <i className='fa fa-book qb_card_icon' aria-hidden='true'></i>
                    </Link>
                ))}
            </div>
        </div>
    )
}

export default SubjectPage
